module.exports = __webpack_public_path__ + "static/media/codepenIcon.80e65977.svg";